<template>
    <!-- <div class="wrapperCard"> -->
        <div class="card">
            <router-link v-if="$route.path !== '/dashboard/profil'" to='/'>
                <img src="../assets/images/LogoPerindo.png" alt="logo" :class="[$route.fullPath === '/'? 'large' : 'small']">
            </router-link>
           <slot></slot>
        </div>
    <!-- </div> -->
</template>

<style lang="scss" scoped>
// .wrapperCard{
    .card{
        width: 500px;
        height: fit-content;
        background-color: $white;
        position: absolute;
        top: 0;
        bottom: 0; /* Aligns Vertically */
        left: 0;
        right: 0; /* Aligns Horizontally */
        margin: auto;
        padding: 2rem 3rem;
        @media only screen and (max-width: 600px) {
            // background-color: transparent !important;
            width: 100%;
            padding: 2rem 1rem;
            max-width: 400px;
        }
        img{
            height: 72px;
            margin: 0 auto;
             @media only screen and (max-width: 600px) {
                 margin: 3rem auto;
             }
        }
        .small{
             @media only screen and (max-width: 600px) {
                //  width: 100px;
             }
        }
    }
// }
</style>
